import React from 'react'

import { theme } from '@acorns/grove'
import styled from 'styled-components'

import { AI_CHAT_USER_SENT_MESSAGE } from 'utils/testing/testIDs'

import { SentMessage as SentMessageType } from './utils/types'

const MessageContainerBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  padding: 0px 20px;
`

const InternalMessageBox = styled.div`
  background-color: ${theme.colors.primarySlate};
  padding: 10px 15px;
  width: fit-content;
  border-radius: 20px;
  color: ${theme.colors.primaryWhite};
  font-size: 14px;
  display: inline-flex;
  text-align: left;
`

const MessageContainer = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  width: 100%;
`

export const SentMessage = ({ message }: { message: SentMessageType }) =>
  message ? (
    <MessageContainerBox
      data-testid={`${AI_CHAT_USER_SENT_MESSAGE}_${message?.id}`}
    >
      <MessageContainer>
        <InternalMessageBox>{message.text}</InternalMessageBox>
      </MessageContainer>
    </MessageContainerBox>
  ) : (
    <></>
  )
